export interface SparklineProps {
  data: readonly number[];
  width?: number;
  height?: number;
  ariaLabel?: string;
}

/** Genera los puntos "x,y" de una polilínea normalizada a la caja dada. */
export function sparkPoints(data: readonly number[], width: number, height: number, pad = 2): string {
  if (data.length === 0) return "";
  const min = Math.min(...data);
  const max = Math.max(...data);
  const span = max - min || 1;
  const stepX = data.length > 1 ? (width - pad * 2) / (data.length - 1) : 0;
  return data
    .map((v, i) => {
      const x = pad + i * stepX;
      const y = pad + (height - pad * 2) * (1 - (v - min) / span);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");
}

export function Sparkline({ data, width = 560, height = 120, ariaLabel }: SparklineProps): JSX.Element {
  const points = sparkPoints(data, width, height);
  const area = points ? `${points} ${width - 2},${height - 2} 2,${height - 2}` : "";
  const gid = `spark-${data.length}-${Math.round(data[0] ?? 0)}`;
  return (
    <svg
      className="sparkline"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      role="img"
      aria-label={ariaLabel}
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--ml-yellow)" stopOpacity="0.35" />
          <stop offset="100%" stopColor="var(--ml-yellow)" stopOpacity="0" />
        </linearGradient>
      </defs>
      {area ? <polygon points={area} fill={`url(#${gid})`} /> : null}
      <polyline
        points={points}
        fill="none"
        stroke="var(--ml-yellow)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
